export default {
    data() {
        return {
            swalOptions: {
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cerrar",
                confirmButtonColor: "#20A8D8",
                cancelButtonColor: "#D7D7D7",
                reverseButtons: true,
            },
        };
    },
    methods: {
        loading() {
            this.$swal({
                text: "Procesando su solicitud, un momento por favor...",
                showConfirmButton: false,
                willOpen: () => {
                    this.$swal.showLoading();
                },
            });
        },

        closeLoading() {
            this.$swal.hideLoading();
        },

        showAlert(type, title, text) {
            this.$swal({
                title: title,
                text: text,
                icon: type,
                type: type,
                confirmButtonText: "Aceptar",
            });
        },

        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },

        showActionError(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "error",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "error",
                title: message,
            });
        },

        showSwalError(html) {
            return this.$swal({
                title: "Ha ocurrido uno o varios errores",
                html,
                icon: "error",
                ...this.swalOptions,
            });
        },

        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },

        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },

        showPassword(id) {
            const el = document.getElementById(id);

            if (el.type == "password") {
                el.type = "text";
            } else {
                el.type = "password";
            }
        },
    },
};
